import React from 'react'

export default function Flower() {
    return <div className='bubble-flower'>
        <img alt="flower" className='bubble-icon-shake' src={process.env.PUBLIC_URL + "/img/wedding-flower.png"} width={30}/>
    </div>
}